// Module
var code = `<table class="misc-transaction__table table">

  <tbody>
  <tr>
    <td>1.</td>
    <td colspan="2">MICR number</td>
    <td>
      <micr-number
        ng-model="\$ctrl.checkModel.micrNumber"
        ng-change="\$ctrl.onMicrNumberChange(\$ctrl.checkModel.micrNumber)"
      ></micr-number>
    </td>
  </tr>
  <tr>
    <td>2.</td>
    <td colspan="2">Valid from</td>
    <td>
      <date
        ng-required="true"
        ng-model="\$ctrl.checkModel.validFrom">
      </date>
    </td>
  </tr>
  <tr>
    <td>3.</td>
    <td>Issuing bank</td>
    <td class="checkbox-column">
      <label ng-if="\$ctrl.onUsCheckAllowed">
        On us check:
        <input type="checkbox"
               ng-model="\$ctrl.checkModel.onUsCheck"
               ng-change="\$ctrl.onOnUsCheckChange()"/>
      </label>
    </td>
    <td>
      <selectize options="\$ctrl.banks"
                 ng-disabled="\$ctrl.checkModel.onUsCheck"
                 config="\$ctrl.selectConfig"
                 ng-model="\$ctrl.checkModel.bankId"
                 ng-required="!\$ctrl.checkModel.onUsCheck">
      </selectize>
    </td>
  </tr>
  <tr>
    <td>4.</td>
    <td colspan="2">Amount</td>
    <td>
      <cash ng-model="\$ctrl.checkModel.amount"
        ng-disabled="\$ctrl.disableAmountInput"
        ng-required="true"
        min="0.01"></cash>
    </td>
  </tr>
  <tr ng-if="!\$ctrl.withoutRemarks">
    <td>5.</td>
    <td colspan="2">Remarks</td>
    <td>
      <input type="text"
             ng-model="\$ctrl.checkModel.remarks"
             ng-required="false">
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/check-form/check-form.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;